import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf00f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "card p-4 mb-4" }
const _hoisted_6 = { class: "fw_600 mb-1" }
const _hoisted_7 = {
  key: 0,
  class: "fs_14 text-muted mb-0"
}
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "card p-4 mb-4" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = { class: "row mt-3" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_14 = {
  key: 0,
  class: "fs_14"
}
const _hoisted_15 = {
  key: 1,
  class: "fs_14"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_24" }, "→", -1))
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_19 = {
  key: 0,
  class: "fs_14"
}
const _hoisted_20 = {
  key: 1,
  class: "fs_14"
}
const _hoisted_21 = {
  key: 2,
  class: "fs_14"
}
const _hoisted_22 = {
  key: 3,
  class: "fs_14"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs_24" }, "→", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Provider Dashboard",
        text: "Provider Dashboard",
        class: "mb-0"
      })
    ]),
    (_ctx.dashboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  type: "h5",
                  localizedKey: "Company",
                  text: "Company",
                  class: "mb-3"
                }),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.dashboard.company.text), 1),
                (_ctx.dashboard.invitedBy)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Invited by",
                        text: "Invited by"
                      }),
                      _createTextVNode(": " + _toDisplayString(_ctx.dashboard.invitedBy.email), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  type: "h5",
                  localizedKey: "Status",
                  text: "Status",
                  class: "mb-3"
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["statusBadge me-2", _ctx.getStatusClass(_ctx.dashboard.profileStatus)])
                  }, _toDisplayString(_ctx.getStatusLabel(_ctx.dashboard.profileStatus)), 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: _normalizeClass(["card p-4 pointer", { 'border-success': _ctx.dashboard.profileCompleted }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/provider/profile')))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      type: "h5",
                      localizedKey: "Company Profile",
                      text: "Company Profile",
                      class: "mb-1"
                    }),
                    (_ctx.dashboard.profileCompleted)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Completed",
                            text: "Completed",
                            class: "text-success"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "To be completed",
                            text: "To be completed",
                            class: "text-warning"
                          })
                        ]))
                  ]),
                  _hoisted_16
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: _normalizeClass(["card p-4 pointer", { 'border-success': _ctx.dashboard.surveyCompleted }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToSurvey()))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      type: "h5",
                      localizedKey: "Due Diligence Survey",
                      text: "Due Diligence Survey",
                      class: "mb-1"
                    }),
                    (_ctx.dashboard.surveyCompleted && !_ctx.dashboard.hasFactories)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Completed",
                            text: "Completed",
                            class: "text-success"
                          })
                        ]))
                      : (_ctx.dashboard.hasFactories)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.dashboard.factorySurveysSubmitted === _ctx.dashboard.factoryCount ? 'text-success' : 'text-warning')
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.dashboard.factorySurveysSubmitted) + "/" + _toDisplayString(_ctx.dashboard.factoryCount) + " ", 1),
                              _createVNode(_component_localized_text, {
                                localizedKey: "production sites completed",
                                text: "production sites completed"
                              })
                            ], 2)
                          ]))
                        : (_ctx.dashboard.profileCompleted)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Add production sites in profile first",
                                text: "Add production sites in profile first",
                                class: "text-warning"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Complete profile first",
                                text: "Complete profile first",
                                class: "text-muted"
                              })
                            ]))
                  ]),
                  _hoisted_23
                ])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}